import { definePreset, palette } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

const VividPreset = definePreset(Material, {
  semantic: {
    primary: palette('#0078ca'),
  },
});

export default VividPreset;
